import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-pdsmisutilization-case',
  templateUrl: './pdsmisutilization-case.component.html',
  styleUrls: ['./pdsmisutilization-case.component.scss']
})
export class PDSmisutilizationCaseComponent {

  pdsForm!: FormGroup;
  UserDetails: any;
  blockList: any[] = [];
  societyList: any[] = [];
  targetForm!: FormGroup;
  financialYears: any[] = [];
  circlesList: any[] = [];
  reportingYears: any[] = [];
  filteredMonths: any[] = [];

  reportData: any[] = [];
  months: any[] = [];
  showButton = false;
  currentMonth: any = {};
  edit = false;
  editId = 0;
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };



  currentYear = new Date().getFullYear();
  //  currentMonth = new Date().getMonth(); // 0-based index
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {
  }

  ngOnInit(): void {

    this.pdsForm = this.fb.group({
      // financialYear: ['', Validators.required],
      blockOffice: [{ value: '', disabled: true }, Validators.required],
      defaulterSociety: [{ value: '', disabled: true }, Validators.required],
      sinceYear: [{ value: '', disabled: true }, Validators.required],
      offilneEntryYear: [{ value: '', disabled: true }, Validators.required],

      balance: [{ value: 0, disabled: true }, Validators.required],
      recoverAmount: ['', Validators.required],
      actionTaken: ['', Validators.required],
      reportingMonth: [],

    });
    this.targetForm = this.fb.group({

      blockOffice: ['', Validators.required],
      defaulterSociety: ['', Validators.required],
      sinceYear: ['', Validators.required],
      offilneEntryYear: ['', Validators.required]

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


         switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
       
    
        break;
      default:
    }
    this.targetForm.get('blockOffice')?.valueChanges
      .pipe(debounceTime(300)).subscribe((val: any) => {
        val && this.getSocieties(val)
      });
    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.GetMisUtilizationData();
        }
      });

    this.getTargetCount();
    //  this.GetYearAndMonth("i") 

  }


     getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        
 
    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
 
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
            
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
          this.targetForm.controls['defaulterSociety'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }
 

  getSocieties(blockId: any) {
    let obj = {
      blockId: blockId
    }
    this.financialYears = [];
    this.reportingYears = []
    this.societyList = []
    this.reportService.GetMisutiliztionDropdown(obj).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.societyList = res.data;


      }
    },
      (error: any) => {
      }
    );
  }


  societyselect(event: any) {
    let val = event.target.value;

    let data = this.societyList.filter((i) => i?.defaulterSociety == Number(val));
    this.financialYears = data;

  }
  sinceYearselect(event: any) {
    let val = event.target.value;

    this.targetForm.controls['offilneEntryYear'].setValue('');
    let data = this.societyList.filter((i) => i?.misutilizationSinceYear == Number(val) && i?.defaulterSociety == this.targetForm.controls['defaulterSociety'].value);
    this.reportingYears = data

  }
  GetYearAndMonth(blockId?: any) {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }

  onSinceYearChange(event: any, prefill?: any) {

    //     const selectedStartYear = parseInt(event.target.value, 10);
    //     const currentFYStart = this.getCurrentFinancialYearStart();

    //     if (!isNaN(selectedStartYear)) {
    //       // Filter financial years from selected startYear to current financial year
    //       this.reportingYears = this.financialYears.filter(
    //         fy => fy.startYear >= selectedStartYear && fy.startYear <= currentFYStart
    //       );

    // if(!prefill){
    //    // Reset dependent fields
    //       this.pdsForm.get('offilneEntryYear')?.setValue('');
    //       this.filteredMonths = [];
    //       this.pdsForm.get('duringMonth')?.setValue('');
    // }


  }




  GetMisUtilizationData() {

    if (this.targetForm.valid) {


      let obj = {
        blockId: this.targetForm.getRawValue()?.blockOffice,
        societyId: this.targetForm.getRawValue()?.defaulterSociety,
        misutilizationSinceYear: this.targetForm.getRawValue()?.sinceYear,
        reportingYear: this.targetForm.getRawValue()?.offilneEntryYear,
      }

      this.reportService.GetMisutilizationReport(obj).subscribe((res: any) => {

        if (res && res?.data && res?.data.length > 0) {
          let lastRow = res?.data[res?.data.length - 1];

          this.reportData = res?.data;


          if (Number(lastRow?.reportingMonth) != 12 && Number(lastRow?.reportingMonth) < 12) {

            let year = (Number(lastRow?.reportingMonth) <= 9) ? this.targetForm.getRawValue()?.offilneEntryYear.split('-')[0] : this.targetForm.getRawValue()?.offilneEntryYear.split('-')[1]

            this.currentMonth.key = (Number(lastRow?.reportingMonth) + 1).toString();
            this.currentMonth.name = this.monthKeyMap[Number(lastRow?.reportingMonth) + 1] + ', ' + year
            this.showButton = true
          } else {
            this.showButton = false
          }


        } else {
          this.reportData = []
          this.showButton = true;
          this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.getRawValue()?.offilneEntryYear.split('-')[0];
          this.currentMonth.key = '1';
          this.toastService.showInfo('NO Data Found!')
        }
      },
        (error: any) => {
        }
      );
    } else {
      this.targetForm.markAllAsTouched();
    }
  }

  addData() {
    let data = this.societyList.find((i) => i?.offlineEntriesYear == this.targetForm.getRawValue()?.offilneEntryYear && i?.misutilizationSinceYear == this.targetForm.getRawValue()?.sinceYear && i?.defaulterSociety == this.targetForm.controls['defaulterSociety'].value);
    this.pdsForm.patchValue({
      // financialYear: this.targetForm.value?.financialYear?.financialYear,
      // blockOffice: this.targetForm.getRawValue()?.blockOffice,
      // dataMonth: this.currentMonth.key
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      defaulterSociety: this.targetForm.getRawValue()?.defaulterSociety,
      sinceYear: this.targetForm.getRawValue()?.sinceYear,
      offilneEntryYear: this.targetForm.getRawValue()?.offilneEntryYear,
      balance: data?.balanceAsOnDate,
      reportingMonth: this.currentMonth?.key
    })

    // this.pdsForm.controls['dataMonth'].disable();
  }

  onSubmit() {
    if (this.pdsForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const formValue = this.pdsForm.getRawValue();

      let obj = {
        blockId: formValue.blockOffice,
        defaulterSociety: formValue.defaulterSociety,
        misutilizationSinceYear: formValue.sinceYear,
        reportingYear: formValue.offilneEntryYear,
        // balanceAsOnDate: new Date().toISOString(), // or any specific logic
        balanceAmount: formValue.balance,
        amountRecovered: formValue.recoverAmount,
        legalActionTaken: formValue.actionTaken,
        reportingMonth: formValue?.reportingMonth,
        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0,



      }



      this.reportService.addMisutilizationReport(obj).subscribe((res: any) => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('CCLPDSMisutilizationDataModal');
            this.pdsForm.reset();
            this.pdsForm.markAsUntouched();
            this.GetMisUtilizationData();
            // this.setFertilizerTypes();
            // this.GetTFertilizerSalePurchase();
          } else {
            this.edit = false
          }

        }

      },
        (error: any) => {
        }
      );


    } else {
      this.pdsForm.markAllAsTouched();
    }
  }

  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  getMonthLabel(month: string, year: string): string {
    const label = this.monthKeyMap[parseInt(month)];
    let displayYear = parseInt(year.split("-")[0]);

    // Adjust year for months Jan to March (since they belong to next calendar year in FY)
    if (['10', '11', '12'].includes(month)) {
      displayYear += 1;
    }

    return `${label}, ${displayYear}`;
  }

  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }

  DeleteMisutilizationReport(id: any) {
    this.reportService.DeleteMisutilizationReport(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisUtilizationData();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyMisutilizationReport(id: any) {
    this.reportService.verifyMisutilizationReport(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetMisUtilizationData();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  editRow(row: any) {
   
    if (!row) return;
    const formValue = this.targetForm.getRawValue();

    let data = this.societyList.find((i) => i?.offlineEntriesYear == this.targetForm.getRawValue()?.offilneEntryYear && i?.misutilizationSinceYear == this.targetForm.getRawValue()?.sinceYear && i?.defaulterSociety == this.targetForm.controls['defaulterSociety'].value);

    
    this.edit = true;
    this.editId = row?.id || 0;

    this.pdsForm.enable();

    this.pdsForm.patchValue({
      blockOffice: formValue.blockOffice,
      defaulterSociety: formValue.defaulterSociety,
      sinceYear: formValue.sinceYear,
      reportingYear: formValue.offilneEntryYear,
      balance: data.balanceAsOnDate,
      offilneEntryYear: row.reportingYear || '',
      recoverAmount: row.amountRecovered ?? '',
      actionTaken: row.legalActionTaken ?? '',
      reportingMonth: row.reportingMonth || ''
    });


    ['blockOffice', 'defaulterSociety', 'sinceYear', 'offilneEntryYear', 'balance']
      .forEach(field => this.pdsForm.get(field)?.disable());

    this.openModal('CCLPDSMisutilizationDataModal');
  }




}


